/* unplugin-vue-components disabled */import script from "./MatchInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchInfo.vue?vue&type=script&setup=true&lang=js"

import "./MatchInfo.vue?vue&type=style&index=0&id=38435638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38435638"]])

export default __exports__